export const _parser = (param?: string | null): any => {
  return JSON.parse(param ? param : JSON.stringify(null));
};
